import { Suspense } from 'react';

import ErrorBoundary from '@cvt/components/ErrorBoundary';
import { BodyLoading } from '@cvt/components/layout/BodyLoading';

import { CreateTribute as CreateTributeView } from '@modules/Tributes/Views/CreateTribute/CreateTribute';


export const CreateTribute: React.FC = () => {
  return (
    <ErrorBoundary>
      <Suspense fallback={<BodyLoading height="100%" />}>
        <CreateTributeView />
      </Suspense>
    </ErrorBoundary>
  );
};
